<template>
	<div class="item border xl-flex-stretch" @click="$router.push({ name: $routes.JobDetails.name, params: { jobId: job.id } })">
		<div class="pad-24 grow">
			<div class="grow flex-col gap-16 md-flex-split md-align-start">
				<div class="bg-violet-03 br-8 pad-12 flex-center gap-4 md-order-10 no-shrink" style="width:114px;">
					<svg v-if="job.queue.type == 'instant'" class="block no-shrink" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.5" fill="#80CC8C" stroke="url(#paint0_linear_6332_38088)"/><path fill="url(#paint1_linear_6332_38088)" fill-rule="evenodd" d="M9.07932 3.16989C9.07938 3.05931 9.03856 2.9518 8.96317 2.86398C8.88779 2.77616 8.78203 2.71292 8.66227 2.68406C8.54251 2.6552 8.41541 2.66232 8.30065 2.70431C8.18588 2.7463 8.08983 2.82083 8.02737 2.91637L4.07692 8.95246C4.02687 9.0289 4.00034 9.11576 4 9.20427C3.99967 9.29277 4.02554 9.37979 4.075 9.45654C4.12446 9.53328 4.19577 9.59703 4.28172 9.64136C4.36767 9.68568 4.46522 9.70901 4.56452 9.70898H6.82192V13.23C6.82185 13.3406 6.86267 13.4481 6.93806 13.5359C7.01345 13.6238 7.1192 13.687 7.23897 13.7159C7.35873 13.7447 7.48582 13.7376 7.60059 13.6956C7.71536 13.6536 7.8114 13.5791 7.87387 13.4836L11.8243 7.44746C11.8744 7.37102 11.9009 7.28416 11.9012 7.19565C11.9016 7.10715 11.8757 7.02013 11.8262 6.94339C11.7768 6.86664 11.7055 6.80289 11.6195 6.75857C11.5336 6.71424 11.436 6.69091 11.3367 6.69094H9.07932V3.16989Z" clip-rule="evenodd"/><defs><linearGradient id="paint0_linear_6332_38088" x1="14.5" x2="0.999999" y1="13.5" y2="2.5" gradientUnits="userSpaceOnUse"><stop stop-color="#009918"/><stop offset="1" stop-color="#009918" stop-opacity="0"/></linearGradient><linearGradient id="paint1_linear_6332_38088" x1="7.5" x2="16" y1="8.5" y2="22.5" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient></defs></svg>
					<svg v-else class="block no-shrink" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
						<circle cx="8" cy="8" r="7.5" fill="#C682FD" stroke="url(#paint0_linear_6612_30915)" />
						<path fill="url(#paint1_linear_6612_30915)" d="M8.10446 10.7417C8.04031 10.7024 7.9595 10.7024 7.89535 10.7417L4.96026 12.5417C4.80705 12.6357 4.61731 12.4956 4.66197 12.3215L5.50024 9.05436C5.5196 8.9789 5.49338 8.89907 5.43305 8.84978L2.79226 6.69213C2.65177 6.57734 2.72442 6.34982 2.90544 6.3377L6.35166 6.1069C6.42767 6.10181 6.49419 6.05398 6.52321 5.98355L7.81499 2.84866C7.88301 2.68359 8.1168 2.68359 8.18482 2.84866L9.47659 5.98355C9.50562 6.05398 9.57213 6.10181 9.64814 6.1069L13.0936 6.33765C13.2747 6.34978 13.3473 6.57751 13.2066 6.69221L10.5602 8.84964C10.4996 8.89899 10.4733 8.97906 10.4929 9.05469L11.3367 12.3205C11.3817 12.4947 11.1919 12.6351 11.0385 12.5411L8.10446 10.7417Z" />
						<defs>
							<linearGradient id="paint0_linear_6612_30915" x1="13.5" x2="1.5" y1="13.5" y2="2" gradientUnits="userSpaceOnUse">
								<stop stop-color="#8D05FB" />
								<stop offset="1" stop-color="#8D05FB" stop-opacity="0" />
							</linearGradient>
							<linearGradient id="paint1_linear_6612_30915" x1="6.49988" x2="11.9999" y1="5.99988" y2="20.9999" gradientUnits="userSpaceOnUse">
								<stop stop-color="#fff" />
								<stop offset="1" stop-color="#fff" stop-opacity="0" />
							</linearGradient>
						</defs>
					</svg>
					<h3 class="fs-12 lh-14">{{ job.queue.type == 'instant' ? 'Instant' : 'Ranked' }} Offer</h3>
				</div>

				<div>
					<!-- Name -->
					<div class="flex-col flex-stretch gap-4 mb-16 lg-mb-20">
						<div class="fs-18 lh-24 lg-fs-18 lg-lh-20">
							<router-link
								:to="{ name: $routes.JobDetails.name, params: { jobId: job.id } }"
								class="color-violet fw-700 job-name"
								@click.native.stop
							>
								{{ job.event.name }}
							</router-link>
						</div>
						<div class="flex wrap gap-8">
							<div class="badge badge-gray" v-if="job.event.type && job.event.type.name">
								{{ job.event.type.name }}
							</div>
						</div>
					</div>

					<!-- Date and time -->
					<div class="job-details">
						<div class="flex fs-14" style="margin: 9px 0;">
							<div class="align-top"><icon-time class="block" /></div>
							<div class="ml-8">
								<div>
									{{ job.event.formattedEventDate.split(',')[0].substring(0,3) }}, {{ job.event.formattedEventDate.split(',')[1] }} | {{ getEventTime(job.event) }}
								</div>
								<div class="fs-12" v-if="job.event.minimumPaidHours">
									Minimum Paid Hours: {{ job.event.minimumPaidHours }}
								</div>
							</div>
						</div>
						<div class="flex fs-14" v-if="formatLocation(job)">
							<div><icon-location class="block" /></div>
							<div class="ml-8">{{ formatLocation(job) }}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Queue -->
			<div class="queue-info flex-col gap-16 pt-16 border-top-07 mt-20">
					<div v-if="queueType == 'ranked'">
						<div class="caps mb-8">Queue Position</div>
						<div class="queue-position">
							{{ job.queue.currentIndex + 1 }}
							<div class="denominator">{{ job.queue.totalCandidates }}</div>
						</div>
					</div>
					<div>
						<div class="caps mb-8">{{ queueType == 'ranked' ? 'Time Remaining' : 'Response Time Limit'}}</div>
						<CountDownNew :to="offerEndTime(job.queue)" :label-size="5" :minimum-integer-digits="2"/>
					</div>
				</div>
		</div>
		
		<!-- Ranked - Current Candidate -->
		<div v-if="queueType == 'ranked'" class="accent-section pad-24 ranked">
			<div class="caps mb-8">Current Respondent</div>
			<div class="flex-top mb-20">
				<ProfileAvatar
					:profile="job.queue.candidates[0].user.profile"
					size="80"
					class="mr-16 square-80"
					@click.native.stop
				/>
				<div>
					<div :class="`badge no-wrap badge-${job.position.name.replace(' ', '-').toLowerCase()}`">{{ job.position.name }}</div>
					<div class="fs-12 fw-500 lh-16 color-violet mt-4">${{ job.queue.candidates[0].ratePerHour }} per hour</div>
					<div class="fs-18 fw-700 mb-4 lh-20 lg-lh-24 color-violet">{{ job.queue.candidates[0].user.name }}</div>
					<Rating :value="job.queue.candidates[0].user.profile" />
				</div>
			</div>
			<div class="flex gap-x-32 gap-y-12 fs-12 color-violet">
				<router-link
					class="inline-flex align-center"
					:to="{ name: $routes.Profile.name, params: { id: job.queue.candidates[0].user.profile.id } }"
					@click.native.stop
				>
					<div class="icon-wrap flex" style="width:24px;"><icon-user/></div>
					<span class="no-wrap">View Profile</span>
				</router-link>
				<router-link
					class="inline-flex align-center"
					:to="{ name: $routes.JobChat.name, params: { jobId: job.id, chatId: job._chatInfo.chatId } }"
					@click.native.stop
				>
					<div class="icon-wrap flex" style="flex:0 0 24px;">
						<div v-if="job._chatInfo.unreadMessagesCount" class="unread-messages-count">{{ job._chatInfo.unreadMessagesCount }}</div>
						<icon-chat />
					</div>
					<span class="no-wrap">Messages</span>
				</router-link>
			</div>
		</div>

		<!-- Instant - active candidates -->
		<div v-else class="accent-section pad-24 flex-col justify-start justify-center text-center">
			<div class="fs-18 lh-20 fw-700 color-violet">
				{{ activeInstantCandidates.length }}
				Current Candidate{{ activeInstantCandidates.length == 1 ? '' : 's' }}
			</div>
			<div class="avatar-list mt-16 mx-auto">
				<ProfileAvatar
					v-for="candidate in activeInstantCandidates.slice(0, 3)"
					:profile="candidate.user.profile"
					:key="`pa${candidate.id}`"
					size="40"
					class="square-40"
					@click.native.stop
				/>
				<div v-if="xMore" class="more square-40 round flex-center fw-700 fs-16">+{{ xMore }}</div>
			</div>
			<p class="fs-12 lh-18 mt-12 mb-16">The first candidate to accept this instant offer will book the job.</p>
		</div>
	</div>
</template>

<script>
import { millisecondsPer } from '@/plugins/time';

export default {
	name: 'ItemJobActiveQueue',
	props: {
		job: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			peopleAvailable: [],
			totalAvailable: 0,
		};
	},
	computed: {
		xMore() {
			return this.activeInstantCandidates.length - this.activeInstantCandidates.slice(0, 3).length;
		},
		queueType() {
			return this.job && this.job.queue ? this.job.queue.type : null;
		},
		activeInstantCandidates() {
			if (this.queueType !== 'instant') return [];

			return this.job.queue.candidates.filter(obj => obj.status == 'awaitingResponse');
		},
	},
	methods: {
		formatLocation(job) {
			const locations = job?.event?.locations;
			const location = locations && locations[0];
			if (!location) {
				return null;
			}
			return this.isTrialing
				? [
						[location.city, location.state].filter(Boolean).join(', '),
						location.zip
					].filter(Boolean).join(' ')
				: location.address;
		},
		getEventTime(event) {
			const start = event.formattedEventStartTime == '12:00 AM' ? 'TBD' : event.formattedEventStartTime;
			const end = event.formattedEventEndTime == '11:59 PM' ? 'TBD' : event.formattedEventEndTime;
			if ( start == 'TBD' && end == 'TBD' ) return 'Time TBD';
			
			return `${start} - ${end}`;
		},
		offerEndTime(queue) {
			const {
				lastProcessedAt,
				responseWindow
			} = queue;
			if (lastProcessedAt != null && responseWindow) {
				return this.$toTimestamp(Date.parse(lastProcessedAt) + responseWindow * millisecondsPer.minute);
			}
			return null;
		},
	},
}
</script>
